(() => {
  document.querySelectorAll('[data-colour-group]:not([data-loading])').forEach(async group => {
    group.dataset.loading = 'true';
    const container = group.querySelector('.available-color-div');
    const seen = new Set([group.dataset.currentHandle]);
    let url = group.dataset.colourUrl;
    try {
      while (url) {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Colour options unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        html.querySelectorAll('[data-colour-handle]').forEach(card => {
          const handle = card.dataset.colourHandle;
          if (!seen.has(handle)) { seen.add(handle); container.append(card); }
        });
        group.hidden = container.children.length === 0;
        url = html.querySelector('[data-colour-next]')?.getAttribute('href') || '';
      }
    } catch (_) { /* Keep already loaded options; omit an empty section. */ }
  });
})();
